import { motion } from 'framer-motion';

const SocialProof = () => {
  return (
    <section className="bg-[#f8f9fa] py-20">
      <div className="container mx-auto px-6 lg:px-20">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-8"
          >
            <div className="flex justify-center items-center space-x-1 mb-4">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-3xl text-[#ff6f00]"></i>
              ))}
              <span className="ml-3 text-2xl font-bold text-[#1a237e]">4.9/5.0</span>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-white rounded-2xl p-8 lg:p-12 shadow-lg relative"
          >
            <div className="absolute top-8 left-8 text-[#ff6f00]/20 text-8xl font-serif leading-none">
              "
            </div>
            <div className="relative z-10">
              <p className="text-xl lg:text-2xl text-gray-700 italic leading-relaxed mb-8 text-center">
                Empresa excelente, rápidos e eficientes. Super responsáveis, utilizo os serviços sempre que preciso. A RBF Express é fundamental para manter nossa operação funcionando sem interrupções.
              </p>
              <div className="flex items-center justify-center">
                <img
                  src="https://r.mobirisesite.com/729997/assets/images/f616aa585534ab6069da20a80a5f42cd-236x236.jpg"
                  alt="Antonieta Leonarda"
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <p className="font-bold text-[#1a237e] text-lg">Antonieta Leonarda</p>
                  <p className="text-gray-600 text-sm">Cliente Empresarial</p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="grid grid-cols-3 gap-8 mt-12"
          >
            <div className="text-center">
              <div className="text-4xl font-bold text-[#1a237e] mb-2">+1.000</div>
              <p className="text-gray-600 text-sm">Entregas Realizadas</p>
            </div>
            <div className="text-center border-l border-r border-gray-300">
              <div className="text-4xl font-bold text-[#1a237e] mb-2">99%</div>
              <p className="text-gray-600 text-sm">Satisfação</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#1a237e] mb-2">15+</div>
              <p className="text-gray-600 text-sm">Anos de Atuação</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
